import * as types from '../../../lib/actionTypes.es6';

export var getOrgSmsTemplatesRequest = function(organizationGuid) {
  return { type: types.GET_ORG_SMS_TEMPLATES_REQUEST, payload: organizationGuid };
};
export var getOrgSmsTemplatesSuccess = function(payload) {
  return { type: types.GET_ORG_SMS_TEMPLATES_SUCCESS, payload: payload };
};
export var getOrgSmsTemplatesFailure = function(error) {
  return { type: types.GET_ORG_SMS_TEMPLATES_FAILURE, payload: error };
};

export var createOrgSmsTemplateRequest = function(payload) {
  return { type: types.CREATE_ORG_SMS_TEMPLATE_REQUEST, payload: payload };
};
export var createOrgSmsTemplateSuccess = function(payload) {
  return { type: types.CREATE_ORG_SMS_TEMPLATE_SUCCESS, payload: payload };
};
export var createOrgSmsTemplateFailure = function(error) {
  return { type: types.CREATE_ORG_SMS_TEMPLATE_FAILURE, payload: error };
};
export var resetCreateOrgSmsTemplateSuccess = function() {
  return { type: types.RESET_CREATE_ORG_SMS_TEMPLATE_SUCCESS };
};
export var resetCreateOrgSmsTemplateError = function() {
  return { type: types.RESET_CREATE_ORG_SMS_TEMPLATE_ERROR };
};

export var updateOrgSmsTemplateRequest = function(payload) {
  return { type: types.UPDATE_ORG_SMS_TEMPLATE_REQUEST, payload: payload };
};
export var updateOrgSmsTemplateSuccess = function(payload) {
  return { type: types.UPDATE_ORG_SMS_TEMPLATE_SUCCESS, payload: payload };
};
export var updateOrgSmsTemplateFailure = function(error) {
  return { type: types.UPDATE_ORG_SMS_TEMPLATE_FAILURE, payload: error };
};
export var resetUpdateOrgSmsTemplateSuccess = function() {
  return { type: types.RESET_UPDATE_ORG_SMS_TEMPLATE_SUCCESS };
};
export var resetUpdateOrgSmsTemplateError = function() {
  return { type: types.RESET_UPDATE_ORG_SMS_TEMPLATE_ERROR };
};

export var deleteOrgSmsTemplateRequest = function(payload) {
  return { type: types.DELETE_ORG_SMS_TEMPLATE_REQUEST, payload: payload };
};
export var deleteOrgSmsTemplateSuccess = function(payload) {
  return { type: types.DELETE_ORG_SMS_TEMPLATE_SUCCESS, payload: payload };
};
export var deleteOrgSmsTemplateFailure = function(error) {
  return { type: types.DELETE_ORG_SMS_TEMPLATE_FAILURE, payload: error };
};
export var resetDeleteOrgSmsTemplateSuccess = function() {
  return { type: types.RESET_DELETE_ORG_SMS_TEMPLATE_SUCCESS };
};
export var resetDeleteOrgSmsTemplateError = function() {
  return { type: types.RESET_DELETE_ORG_SMS_TEMPLATE_ERROR };
};
